import auth from '../modules/auth';
import countries from '../modules/countries';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as notificationReducer } from '../modules/notification';
import { reducer as simulateurReducer } from '../modules/simulateur';
import { reducer as tunnelReducer } from '../modules/tunnel';
import { connectRouter } from 'connected-react-router';
import { citraDataReducer } from './citraData/citraDataReducer';

export default (history) => combineReducers({
  router: connectRouter(history),
  auth,
  form: formReducer,
  simulateur: simulateurReducer,
  tunnel: tunnelReducer,
  countries,
  notification: notificationReducer,
  citraData: citraDataReducer
});
